import { appLocalStorage } from '@/app/shared/commonURLs';

let NursePortalUrl = appLocalStorage.NursePortalUrl;
let NursePortalODataUrl = appLocalStorage.NursePortalODataUrl;
let SecurityUrl = appLocalStorage.SecurityServiceUrl;
//let CPOEUrl = appLocalStorage.CpoeUrl;
let pmgtURL = appLocalStorage.PmgtServiceUrl;
let SupplyChainUrl = appLocalStorage.SupplyChainUrl;
let CPOEBackOfficeUrl = appLocalStorage.CPOEBackOfficeUrl;

export class uRls {
    constructor() {
        this.MedicationAdministrationServicesList = MedicationAdministrationURls();
        this.CpoeServicesList = CpoeURls();
        this.PmgtServicesList = pmgtURLS();
        this.SupplyChainServicesList = ScURls();
        this.SecurityServiceList = SecurityURls();

    }
}

const MedicationAdministrationURl = new uRls();
const CpoeURL = new uRls();

export { MedicationAdministrationURl, CpoeURL };

function MedicationAdministrationURls() {
    var services = {};

    services["GetMedicationOrderlinesForAdministration"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetMedicationOrderlinesForAdministration',
    }

    services["GetMedicationAdministrationStaticData"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetStaticData',
    }

    services["GetDoseActions"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetDoseActions',
    }

    services["GetReasonsByClassificationID"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetReasonsByClassificationID',
    }

    services["GetNurseStationEmployees"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'LabNurse/GetNurseStationEmployees',
    }

    services["GetAllNurses"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'LabNurse/GetAllNurses',
    }

    services["GetDosesToRescheduleOData"] = {
        Method: 'GET',
        URL: NursePortalODataUrl + 'DosesToRescheduleOData',
    }

    services["GetMedicationDispensedItemsOData"] = {
        Method: 'GET',
        URL: NursePortalODataUrl + 'MedicationDispensedItemsOData',
    }

    services["GetDispensedItemActionHistoryOData"] = {
        Method: 'GET',
        URL: NursePortalODataUrl + 'DispensedItemActionHistoryOData',
    }


    services["SaveDispenseItems"] = {
        Method: 'POST',
        URL: NursePortalUrl + 'MedicationAdministration/SaveDispenseItems',
    }

    services["DeleteOrReturnDispensedItem"] = {
        Method: 'POST',
        URL: NursePortalUrl + 'MedicationAdministration/DeleteOrReturnDispensedItem',
    }

    
    services["GetAssignedWarehouses"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetAssignedWarehouses',
    }

    
    services["GetProductDetailsByBarcodeAndFilterByAssignedWH"] = {
        Method: 'GET',
        URL: NursePortalUrl + 'MedicationAdministration/GetProductDetailsByBarcodeAndFilterByAssignedWH'
    };

    services["CheckPinCode"] = {
        Method: 'GET',
        URL: SecurityUrl + 'User/CheckPinCode',
    };

    return services;
}

function CpoeURls() {
    var services = {};

    services["RetrieveOverDueDoses"] = {
        Method: 'GET',
        URL: CPOEBackOfficeUrl + 'MedicationOrderlineInstance/RetrieveOverDueDoses',
    }

    services["ChangeMedciationInstancesStatuses"] = {
        Method: 'POST',
        URL: CPOEBackOfficeUrl + 'MedicationOrderLine/ChangeMedciationInstancesStatuses',
    }

    services["ChangeOverdueMedciationInstancesStatuses"] = {
        Method: 'POST',
        URL: CPOEBackOfficeUrl + 'MedicationOrderLine/ChangeOverdueMedciationInstancesStatuses',
    }

    services["CreateDoseInsatnce"] = {
        Method: 'POST',
        URL: CPOEBackOfficeUrl + 'MedicationOrderLine/CreateDoseInsatnce',
    }

    services["GetTheMedicationInstanceLog"] = {
        Method: 'GET',
        URL: CPOEBackOfficeUrl + 'MedicationOrderLine/GetTheMedicationInstanceLog',
    }

    services["RescheduleMedicationDose"] = {
        Method: 'POST',
        URL: CPOEBackOfficeUrl + 'MedicationOrderlineInstance/RescheduleMedicationDose',
    }



    return services;

}

function pmgtURLS() {
    var services = {};


    services["GetProductDetails"] = {
        Method: 'Get',
        URL: pmgtURL + 'Product/GetProductDetails',
    }


    services["GetFilteredWarehouses"] = {
        Method: 'Get',
        URL: pmgtURL + 'Warehouse/GetFilteredWarehouses',
    }



    return services;
}


function ScURls() {

    var services = {};

    services["GetAvailableBatches"] = {
        Method: 'Get',
        URL: SupplyChainUrl + 'ProductBatches/GetAvailableBatches',
    };

    services["GetWarehouseLocation"] = {
        Method: 'POST',
        URL: SupplyChainUrl + 'SCLookUp/GetAssignedWarehousesLocationsForProduct'
    };


    services["GetProductDetailsByBarcode"] = {
        Method: 'GET',
        URL: SupplyChainUrl + 'SupplyChainProduct/GetProductDetailsByBarcode'
    };


    return services;
}

function SecurityURls() {

    var services = {};

    services["CheckPinCode"] = {
        Method: 'Get',
        URL: SecurityUrl + 'User/CheckPinCode',
    };

    return services;
}
